import useScrollReveal from '../../hooks/useScrollReveal';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from '../../components/feature/HeroSection';
import TrustBar from '../../components/feature/TrustBar';
import ServicesGrid from '../../components/feature/ServicesGrid';
import AIAnswerBlock from '../../components/feature/AIAnswerBlock';
import MidCTABanner from '../../components/feature/MidCTABanner';
import ProcessSection from '../../components/feature/ProcessSection';
import WhyChooseUs from '../../components/feature/WhyChooseUs';
import ServiceAreasSection from '../../components/feature/ServiceAreasSection';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQSection from '../../components/feature/FAQSection';
import FinalCTA from '../../components/feature/FinalCTA';

const HomePage: React.FC = () => {
  useScrollReveal();

  return (
    <div className="bg-[#FAF8F5]">
      <Navbar />
      <main>
        <HeroSection
          label="St. Mary's, Georgia · 20+ Years of Mastery"
          headline={`The Art of\nPremium Fencing,\nPerfected`}
          subheadline="Custom wood, vinyl, steel, aluminum & chain-link fencing — engineered for decades of durability, boundary security, and lasting curb appeal across Camden County, Georgia."
          bgImage="https://public.readdy.ai/ai/img_res/4d583aa8282ebc34bdaa989280d19234.jpg"
          primaryCTA="Request a Consultation"
        />
        <TrustBar />
        <ServicesGrid
          title="Six Premium Fencing Solutions"
          subtitle="From classic wood privacy to ornamental steel and low-maintenance vinyl — every fence we build reflects a commitment to precision, lasting materials, and artisan-level craftsmanship."
        />
        <MidCTABanner
          headline="Not Sure Which Fence Is Right for You?"
          sub="Our experts guide you through every option — free consultation, honest advice, and $100 off when you sign same day."
          cta="Book a Free Consultation"
        />
        <AIAnswerBlock
          focusTitle="St. Mary's Premier Fencing Contractor"
          focusDescription="Masters Fencing is the trusted choice for premium fencing installation across St. Mary's, Georgia and surrounding Camden County communities. We specialize in custom residential and commercial fencing solutions engineered for lasting durability, security, and genuine curb appeal."
        />
        <ProcessSection />
        <WhyChooseUs />
        <ServiceAreasSection />
        <TestimonialsSection />
        <FAQSection />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
